module.exports = __webpack_public_path__ + "media/images/product/p_s-898ea267ceb34a22cc3a14852a71abe3.png";